import env from 'Env';

export default function debug(...args) {
  if (env.isDevelopment || window.fan_debug) {
    console.trace('FAN DEBUG', ...args); // eslint-disable-line no-console
  }
}
